import { render, staticRenderFns } from "./shop-bind.vue?vue&type=template&id=674004f0&scoped=true&"
import script from "./shop-bind.vue?vue&type=script&lang=js&"
export * from "./shop-bind.vue?vue&type=script&lang=js&"
import style0 from "./shop-bind.vue?vue&type=style&index=0&id=674004f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674004f0",
  null
  
)

export default component.exports